
//Vendor
import gsap from 'gsap'
import { Flip } from "gsap/Flip"
gsap.registerPlugin(Flip)

//Custom
import Component from '../classes/Component'
// import { getProfilSlug } from '../utils/wordpress'

export default class Profil extends Component {
  constructor() {
    super({
      container: '.profil__wrapper',
      elements: {
        profil: '.profil__item',
        profilTitle: '.profil__title',
        services: '.profil__service',
        toggleWrapper: '.toggle__wrapper',
        membership: '.membership',
        // cursor: '.cursor__wrapper',
      }
    })

    //Variables
    this.isMember = {}
    this.elements.profil.forEach(profil => this.isMember[profil.dataset.id] = true)
    this.elements.membership.forEach(toggle => toggle.checked = true)
    this.profilId = 0
    this.profilIds = []
    //Methods
    this.container && this.init()
  }

  init() {
    document.querySelector('body').classList.add('stop-scrolling')

    //Handle click event on profil section
    this.elements.profil.forEach((elm) => {
      elm.addEventListener('click', () => { this.onClick(elm) }, false)
    })

    //Handle click event on service item
    this.elements.services.forEach(elm => {
      elm.addEventListener('click', (e) => {
        //Check if service is arleady trigged
        if (document.documentElement.classList.contains('getService')) return

        //stopPropagation
        e.stopPropagation()
        //Dispatch Event   
        document.documentElement.classList.add('getService')
        window.dispatchEvent(new CustomEvent('getService', { detail: { id: elm.dataset.id } }))
      })
    })

    //Handle change in Toggle switch
    this.elements.membership.forEach(toggle => (
      toggle.addEventListener('click', this.onToggle.bind(this), false)
    ))

  }


  /**
   * Events
  */
  async onToggle(event) {
    //stopPropagation
    event.stopPropagation()
    //
    // if (this.isMember != event.target.checked) {
    this.isMember[this.profil.dataset.id] = event.target.checked
    //
    await this.hideServices(this.elements.services, false)
    //
    this.onFilter()
    //
    this.showServices(this.profil.querySelectorAll('.is__active'), false)
    // }
  }

  async onClick(el) {

    this.profil = el
    //
    if (!el.classList.contains('is__actived')) {
      //Cursor
      // this.elements.cursor.classList.add('is__default')
      //
      this.onFilter()
      //
      if (el.classList.contains('is__disabled')) {
        await this.hideServices(this.elements.services)
      }
      //Get initial State
      this.state = Flip.getState([...this.elements.profil])
      //Edit element state
      this.elements.profil.forEach((elm) => {
        elm.classList.remove('is__disabled', 'is__actived')
        elm === el ? elm.classList.add('is__actived') : elm.classList.add('is__disabled')
      })
      //animate state
      Flip.from(this.state, {
        duration: 1,
        nested: true,
        // absolute: true,
        // spin : true,
        // scale : true,
        ease: "power1.inOut",
        onComplete: () => {
          this.showServices(el.querySelectorAll('.profil__service'))
        }
      })
    }
  }

  onFilter() {
    this.elements.services.forEach(elm => {

      if (elm.dataset.member === undefined || elm.dataset.profil != this.profil.dataset.id) return
      if (elm.dataset.member === this.isMember[this.profil.dataset.id].toString()) {
        elm.classList.add('is__active')
      } else {
        elm.classList.remove('is__active')
      }

    })

  }


  reset() {

    this.hideServices(this.elements.services, true)
    //
    this.elements.services.forEach(elm => elm.classList.remove('is__active'))
    gsap.set(this.elements.services, { clearProps: true })
    //
    this.elements.profil.forEach((elm) => {
      elm.classList.remove('is__disabled', 'is__actived')
    })

  }


  /**
   * Animations
   */

  showServices(items, toggle = true) {
    //Show services
    gsap.to(items, {
      autoAlpha: 1,
      y: 0,
      duration: 1,
      stagger: 0.1,
      ease: "back.inOut(1.7)",
      onComplete: () => {
        //Show Toggle Switch
        toggle && gsap.to(this.profil.querySelector('.toggle__wrapper'), { autoAlpha: 1, height: 'auto', duration: 0.5 })
      }
    })
  }

  hideServices(items, toggle = true) {
    //Hide Toggle Switch
    toggle && gsap.set(this.elements.toggleWrapper, { autoAlpha: 0, height: 0 })
    //Hide services
    return gsap.to(items, {
      autoAlpha: 0,
      y: '100%',
      duration: 0.4,
      stagger: 0.05,
      ease: "back.inOut(1.7)"
    })
  }

}